(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        chartTypes(
            module.exports,
            require('../../../../public/enums/metrics.js').sources,
            require('../../../../public/enums/metrics.js').sourceDetails,
            require('../../../../public/enums/widgets.js').widgetTypes,
            require('../../../../public/enums/widgets.js').widgetGroupType,
            require('../../../../public/enums/insightsObjectType.js'),
            require('../../../../public/modules/metric/search.js'),
            require('../../../../public/strings/strings.js'),
            require('lodash')
        );

    } else {
        RivalIQ.apps.Favorites.module('data');
        RivalIQ.apps.Favorites.data.chartTypes = {};
        chartTypes(
            RivalIQ.apps.Favorites.data.chartTypes,
            RivalIQ.enums.sources,
            RivalIQ.enums.sourceDetails,
            RivalIQ.enums.widgetTypes,
            RivalIQ.enums.widgetGroupType,
            RivalIQ.enums.insightsObjectType,
            RivalIQ.metric.search,
            RivalIQ.strings,
            window._
        );
    }

    function chartTypes(exports, sources, sourceDetails, widgetTypes, widgetGroupType, insightsObjectType, searchFn, strings, _) {

        function metricSupportsBenchmarkLine() {
            const me = this;
            const metric = _.head(me.get('metrics') || me.metrics);
            const source = searchFn.getPropertyValue(metric, 'source');

            // If this is a public source, we support the benchmarks:
            if (source === sources.CROSS_CHANNEL || _.includes(sourceDetails[sources.CROSS_CHANNEL].subSources, source)) {
                return true;
            } else {
                const hasMultiPrivateChannelAdvanced = RivalIQ.state.plan.get('has_multi_handle_private_advanced');

                // otherwise, we only support benchmarks on private data iff the customer has has_multi_handle_private_advanced
                if (sourceDetails[source].privateData && hasMultiPrivateChannelAdvanced) {
                    return true;
                }
            }

            return false;
        }

        function availableSources() {
            // Accounts without has_multi_handle_private_basic will not get access to private sources in the landscape widgets.
            const publicOnly = !RivalIQ.state.plan.get('has_multi_handle_private_basic');
            if (publicOnly) {
                const sources = RivalIQ.data.channels.forAnalyze().notHidden(true).filter(function (channel) {
                    const isPrivate = RivalIQ.enums.sourceDetails[channel.id].privateData;
                    return !isPrivate;
                });
                return sources;
            }
        }

        function landscapeMetricAvailableSources() {
            // Accounts without has_multi_handle_private_advanced do not get aggregates on private metrics, so the landscape aggregate
            // widgets (e.g., landscape glance) don't show private data.
            const publicOnly = !RivalIQ.state.plan.get('has_multi_handle_private_advanced');
            if (publicOnly) {
                const sources = RivalIQ.data.channels.forAnalyze().notHidden(true).filter(function (channel) {
                    const isPrivate = RivalIQ.enums.sourceDetails[channel.id].privateData;
                    return !isPrivate;
                });
                return sources;
            }
        }

        // Each entry in chartTypes will be made available to the Favorites
        // builder. Widgets are grouped by widgetGroupId, widgets w/ the same
        // group can be toggled between in the builder. We sometimes override
        // processProps for extra customizablility. getMetricDefaults is called
        // to build the baseMetric of each widget.
        const chartTypes = exports;

        const barChart = {
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            supportsInterval: _.constant(false)
        };

        const pieChart = {
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            supportsInterval: _.constant(false)
        };

        function superProcessProps(widget, props, changed) {
            return Object.getPrototypeOf(widget).processProps.call(widget, props, changed);
        }

        chartTypes[widgetTypes.METRIC_BAR_CHART] = _.extend({}, barChart, {
            widgetId: widgetTypes.METRIC_BAR_CHART,
            name: 'Bar/Stacked',
            icon: 'charts/bar.svg',
            widgetGroupId: widgetGroupType.CHART,
            builderDescription: strings.favorites_chart_type_bar_stacked_description,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: metricSupportsBenchmarkLine,
            widgetSupportsTitlePlacement: true,
            availableSources: availableSources
        });

        chartTypes[widgetTypes.METRIC_BAR_CHART_WITH_CHANGE] = _.extend({}, barChart, {
            widgetId: widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
            name: 'Bar/Stacked with % Change',
            icon: 'charts/bar.svg',
            widgetGroupId: widgetGroupType.CHART,
            builderDescription: strings.favorites_chart_type_bar_stacked_with_percent_change_description,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: metricSupportsBenchmarkLine,
            widgetSupportsTitlePlacement: true,
            availableSources: availableSources
        });

        chartTypes[widgetTypes.COMPANY_PIE_CHART] = _.extend({}, pieChart, {
            widgetId: widgetTypes.COMPANY_PIE_CHART,
            widgetGroupId: widgetGroupType.CHART,
            name: 'Pie Chart',
            icon: 'charts/pie.svg',
            builderDescription: strings.favorites_chart_type_pie_chart_description,
            widgetSupportsTitlePlacement: true,
            availableSources: availableSources,
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, {
                    nameDimensions: ['channel']
                });

                return superProcessProps(me, props, changed);
            }
        });

        chartTypes[widgetTypes.METRIC_COMPANY_LINE_CHART] = {
            widgetId: widgetTypes.METRIC_COMPANY_LINE_CHART,
            name: 'Time Series',
            icon: 'charts/line.svg',
            builderDescription: strings.favorites_chart_type_time_series_description,
            widgetGroupId: widgetGroupType.CHART,
            supportsInterval: _.constant(true),
            intervalAppliesToAllMetrics: false,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: metricSupportsBenchmarkLine,
            widgetSupportsTitlePlacement: true,
            availableSources: availableSources,

            getMetricDefaults: function (metrics) {
                const metric = _.head(metrics);
                let interval;
                if (metric) {
                    interval = searchFn.getPropertyValue(_.head(metrics), 'defaultTimeSeriesInterval');
                }
                interval = interval || 'day';

                return {
                    dimensions: ['timeAnalysisMode', 'companyId', interval, 'channel']
                };
            }
        };

        chartTypes[widgetTypes.METRIC_XY_CHART] = {
            widgetId: widgetTypes.METRIC_XY_CHART,
            name: '2D-Scatter Plot',
            icon: 'charts/xy.svg',
            builderDescription: strings.favorites_chart_type_2d_scatter_plot_description,
            widgetGroupId: widgetGroupType.CHART,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            supportsInterval: _.constant(false),
            widgetSupportsTitlePlacement: true,
            availableSources: availableSources
        };

        chartTypes[widgetTypes.METRIC_TABLE] = {
            widgetId: widgetTypes.METRIC_TABLE,
            name: 'Table',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_table_description,
            supportsInterval: function () {
                const me = this;
                const metrics = me.metricsCollection;
                for (const model of metrics.models) {
                    if (model.get('showSparkline')) {
                        return true;
                    }
                }
                return false;
            },
            intervalAppliesToAllMetrics: false,
            widgetGroupId: widgetGroupType.CHART,
            widgetSupportsBenchmarkLine: function () {
                const me = this;
                const primaryDimension = me.getProp('primaryDimension');
                return primaryDimension !== 'companySetId';
            },
            metricSupportsBenchmarkLine: true,
            widgetSupportsCustomSummary: true,
            widgetSupportsTitlePlacement: true,
            availableSources: function () {
                const me = this;

                // Accounts without has_multi_handle_private_basic will not get access to private sources in the landscape widgets.
                // As a temporary band-aid until https://github.com/RivalIQ/rivaliq-server/issues/32408 lands, this table doesn't support
                // private sources in companySet mode.
                const publicOnly = !RivalIQ.state.plan.get('has_multi_handle_private_basic') || me.getProp('primaryDimension') === 'companySetId';
                if (publicOnly) {
                    const sources = RivalIQ.data.channels.forAnalyze().notHidden(true).filter(function (channel) {
                        const isPrivate = RivalIQ.enums.sourceDetails[channel.id].privateData;
                        return !isPrivate;
                    });
                    return sources;
                }
            },
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            defaultProps: {
                dimensionColumns: true,
                showDescriptions: true,
                limit: 8,
                filter: true,
                trailingBar: true,
                nameDimensions: ['channel', 'timeAnalysisMode'],
                showCustomSummary: false,
                primaryDimension: 'companyId',
                onlyCompanySetIds: null
            },
            propsToOmitFromSerialization: ['rowExpansions'],
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, me.defaultProps);

                props.metrics = _.map(props.metrics, metric => {
                    const dimensions = _.without(metric.dimensions, 'companySetId');
                    metric.dimensions = _.union(['timeAnalysisMode', props.primaryDimension, 'companyId', 'channel'], dimensions);

                    if (props.primaryDimension === 'companySetId') {
                        if (!_.startsWith(metric.companyIdAggregate, 'companies')) {
                            const isSummable = new RivalIQ.models.MetricDefinition(metric).isSummable();
                            metric.companyIdAggregate = isSummable ? 'companiesSum' : 'companiesAverage';
                        }
                    }

                    return metric;
                });

                if (props.secondaryDimension) {
                    props.dimension = props.secondaryDimension;
                } else {
                    delete props.dimension;
                }

                if (props.primaryDimension === 'companySetId') {
                    props.selectedBenchmarkCompareAgainst = null;
                    props.showCustomSummary = false;
                    props.primaryDimensionSummaryRowAggregate = 'useMetricAggregate';
                    props.columnWidth = 12;
                }

                // NOTE b/c dimensionColumns is true we will add a dimension
                // column so sortBy is the metric length
                if (changed.metrics || _.isUndefined(props.orderBy)) {
                    props.orderBy = props.metrics.length;
                }

                return superProcessProps(me, props, changed);
            },
            maxMetrics: function () {
                const me = this;

                if (me.getProp('columnWidth') === 6) {
                    return 4;
                } else {
                    return 8;
                }
            }
        };

        chartTypes[widgetTypes.LANDSCAPE_GLANCE] = {
            widgetId: widgetTypes.LANDSCAPE_GLANCE,
            name: 'At a Glance',
            icon: 'charts/metric-summary.svg',
            builderDescription: strings.favorites_chart_type_landscape_at_a_glance_description,
            widgetGroupId: widgetGroupType.CHART,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: true,
            widgetSupportsCustomSummary: true,
            widgetSupportsTitlePlacement: false,
            isLandscapeAggregateWidget: true,
            requiresMultiHandlePrivateAdvanced: true,
            availableSources: landscapeMetricAvailableSources,
            maxMetrics: 4,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'channel']

                };
            },
            processProps: function (props, changed) {
                const me = this;

                if (!_.isEmpty(props.metrics) && props.metrics.length !== _.size(props.customSummaryMetrics)) {
                    props.customSummaryMetrics = props.customSummaryMetrics || [];
                    _.each(props.metrics, (metric, idx) => {
                        if (!props.customSummaryMetrics[idx]) {
                            props.customSummaryMetrics[idx] = 'all_companies_average';
                        }
                    });
                }
                props.showCustomSummary = true;
                props.focusCompanyTitlePlacement = RivalIQ.enums.widgetFocusCompanyTitlePlacement.NONE;

                return superProcessProps(me, props, changed);
            },
            supportsInterval: function () {
                const me = this;
                const metrics = me.metrics;
                for (const metric of metrics) {
                    if (metric.showSparkline) {
                        return true;
                    }
                }
                return false;
            },
            intervalAppliesToAllMetrics: false,
            getBenchmarkItems: function () {
                return [{
                    id: 'NO_BENCHMARK',
                    name: 'None'
                }, {
                    id: 'previousPeriod',
                    name: 'Previous Period',
                    description: RivalIQ.strings.time_analysis_mode_percentage_change_description
                }];
            }
        };

        chartTypes[widgetTypes.COMPANY_TABLE] = {
            widgetId: widgetTypes.COMPANY_TABLE,
            name: 'Focus Company Table',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_focus_company_table_description,
            supportsInterval: _.constant(true),
            intervalAppliesToAllMetrics: false,
            widgetGroupId: widgetGroupType.CHART,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: true,
            widgetSupportsTitlePlacement: true,
            getMetricDefaults: function () {
                return {
                    timeAnalysisMode: undefined,
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                };
            }
        };

        chartTypes[widgetTypes.COMPANY_METRIC_SUMMARY] = {
            widgetId: widgetTypes.COMPANY_METRIC_SUMMARY,
            name: 'Focus Company Metric Summary',
            icon: 'charts/metric-summary.svg',
            builderDescription: strings.favorites_chart_type_focus_company_metric_summary_description,
            widgetGroupId: widgetGroupType.CHART,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            supportsInterval: _.constant(true),
            intervalAppliesToAllMetrics: false,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: metricSupportsBenchmarkLine,
            widgetSupportsTitlePlacement: true
        };

        chartTypes[widgetTypes.FOCUS_COMPANY_GLANCE] = {
            widgetId: widgetTypes.FOCUS_COMPANY_GLANCE,
            name: 'Focus Company at a Glance',
            icon: 'charts/table-glance.svg',
            builderDescription: strings.favorites_chart_type_focus_company_at_a_glance_description,
            widgetGroupId: widgetGroupType.CHART,
            widgetSupportsBenchmarkLine: true,
            metricSupportsBenchmarkLine: true,
            widgetSupportsTitlePlacement: true,
            maxMetrics: 4,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                };
            },
            supportsInterval: function () {
                const me = this;
                const metrics = me.metrics;
                for (const metric of metrics) {
                    if (metric.showSparkline) {
                        return true;
                    }
                }
                return false;
            },
            intervalAppliesToAllMetrics: false
        };

        chartTypes[widgetTypes.SOCIAL_POSTS] = {
            widgetId: widgetTypes.SOCIAL_POSTS,
            name: 'Social Posts',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_social_posts_description,
            widgetGroupId: widgetGroupType.LIST,
            disableChartTypeSelector: true,
            widgetSupportsTitlePlacement: true,
            getMetricDefaults: function () {
                return {
                    dimensions: ['post', 'timeAnalysisMode', 'channel']
                };
            },
            supportsInterval: _.constant(false),
            defaultProps: {
                limit: 10,
                orderBy: 2,
                sortable: true
            },
            propsToSerialize: [
                'metrics',
                'channel',
                'type',
                'layout',
                'limit',
                'searchTerm',
                'postTagIds',
                'postTagConjunction',
                'postTagExclude',
                'showPostTags'
            ],
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, me.defaultProps);

                let limit = me.defaultProps.limit;
                if (props.layout && props.layout !== 'list') {
                    limit = 12;
                }

                props.limit = limit;

                return superProcessProps(me, props, changed);
            }
        };

        chartTypes[widgetTypes.MEDIA_WIDGET] = _.defaults({

            getMetricDefaults: function () {
                return {
                    dimensions: [insightsObjectType.post, 'timeAnalysisMode', 'channel'],
                    objectType: insightsObjectType.post
                };
            },

            propsToSerialize: _.without(_.union(
                chartTypes[widgetTypes.SOCIAL_POSTS].propsToSerialize,
                ['source', 'mediaTypeFilter', 'orderBy', 'focusCompanyTitlePlacement']
            ), ['channel', 'type']),

            widgetId: widgetTypes.MEDIA_WIDGET
        }, chartTypes[widgetTypes.SOCIAL_POSTS]);

        chartTypes[widgetTypes.FOCUS_COMPANY_SOCIAL_POSTS] = _.defaults({

            propsToSerialize: _.without(_.union(
                chartTypes[widgetTypes.SOCIAL_POSTS].propsToSerialize,
                ['source', 'mediaTypeFilter', 'orderBy', 'focusCompanyTitlePlacement']
            ), ['channel', 'type']),

            widgetId: widgetTypes.FOCUS_COMPANY_SOCIAL_POSTS,
            name: 'Social Posts for Focus Company',
            builderDescription: strings.favorites_chart_type_focus_social_posts_description
        }, chartTypes[widgetTypes.SOCIAL_POSTS]);

        function instagramInsightsPickerRenderState(widgetState, dashboardModel) {
            const source = RivalIQ.enums.sources.INSTAGRAM_INSIGHTS;
            if (RivalIQ.props.channelRedacted(dashboardModel.getProps(), source)) {
                const oAuthUrl = RivalIQ.channels.getOAuthUrl(source);
                return {
                    className: 'disabled',
                    description: `This widget cannot be added because Instagram Insights is not connected. <a href="${oAuthUrl}">Connect Instagram Insights</a>.`
                };
            }

            const companies = _.get(widgetState, ['metadata', 'companies']);
            const companiesInLandscape = _.reduce(companies, function (sum, presence) {
                const company = RivalIQ.state.landscape.get('companies').get(presence.id);
                return (company ? sum + 1 : sum);
            }, 0);

            if (companiesInLandscape === 0) {
                return {
                    className: 'disabled',
                    description: 'This widget cannot be added because the focus company in this landscape does not have access to Instagram Insights'
                };
            }
        }

        // Deprecated, this chartType will be removed with twitter analytics launch.
        chartTypes[widgetTypes.INSTAGRAM_INSIGHTS_POSTS] = {
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_POSTS,
            name: 'Insights Posts',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_insights_posts_description,
            widgetGroupId: widgetGroupType.INSTAGRAM_INSIGHTS_POSTS,
            widgetSupportsTitlePlacement: true,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'post', 'channel', 'companyId']
                };
            },
            supportsInterval: _.constant(false),
            defaultProps: {
                orderBy: 2,
                sortOrder: 1,
                limit: 10,
                post_metrics: [
                    'engagement_total',
                    'reach',
                    'engagement_rate'
                ]
            },
            propsToSerialize: [
                'source',
                'metrics',
                'companyId',
                'mediaTypeFilter',
                'limit',
                'layout',
                'orderBy',
                'searchTerm',
                'focusCompanyTitlePlacement'
            ],
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, me.defaultProps);

                let limit = me.defaultProps.limit;
                if (props.layout && props.layout !== 'list') {
                    limit = 12;
                }

                props.limit = limit;

                return superProcessProps(me, props, changed);
            }
        };

        chartTypes[widgetTypes.INSTAGRAM_INSIGHTS_STORYDAYS] = {
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_STORYDAYS,
            name: 'Instagram Insights Stories',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_instagram_insights_storydays_description,
            widgetGroupId: widgetGroupType.INSTAGRAM_INSIGHTS_STORYDAYS,
            widgetSupportsTitlePlacement: true,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'storyDay', 'channel', 'companyId']
                };
            },
            supportsInterval: _.constant(false),
            defaultProps: {
                orderBy: 2,
                sortOrder: 1,
                limit: 10,
                source: sources.INSTAGRAM_INSIGHTS,
                storyDay_metrics: [
                    'num_stories',
                    'max_reach',
                    'stories_retention_rate',
                    'replies'
                ]
            },
            propsToSerialize: [
                'source',
                'metrics',
                'companyId',
                'mediaTypeFilter',
                'limit',
                'layout',
                'orderBy',
                'searchTerm',
                'focusCompanyTitlePlacement'
            ],
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, me.defaultProps);

                let limit = me.defaultProps.limit;
                if (props.layout && props.layout !== 'list') {
                    limit = 12;
                }

                props.limit = limit;

                return superProcessProps(me, props, changed);
            },
            getPickerRenderState: instagramInsightsPickerRenderState
        };

        chartTypes[widgetTypes.INSTAGRAM_INSIGHTS_STORIES] = {
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_STORIES,
            name: 'Instagram Insights Frames',
            icon: 'charts/table.svg',
            builderDescription: strings.favorites_chart_type_instagram_insights_stories_description,
            widgetGroupId: widgetGroupType.INSTAGRAM_INSIGHTS_STORIES,
            widgetSupportsTitlePlacement: true,
            getMetricDefaults: function () {
                return {
                    dimensions: ['timeAnalysisMode', 'story', 'channel', 'companyId']
                };
            },
            supportsInterval: _.constant(false),
            defaultProps: {
                orderBy: 2,
                sortOrder: 1,
                limit: 10,
                source: sources.INSTAGRAM_INSIGHTS,
                story_metrics: [
                    'reach',
                    'impressions',
                    'completion_rate'
                ]
            },
            propsToSerialize: [
                'source',
                'metrics',
                'companyId',
                'mediaTypeFilter',
                'limit',
                'layout',
                'orderBy',
                'searchTerm',
                'focusCompanyTitlePlacement'
            ],
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, me.defaultProps);

                let limit = me.defaultProps.limit;
                if (props.layout && props.layout !== 'list') {
                    limit = 12;
                }

                props.limit = limit;

                return superProcessProps(me, props, changed);
            },
            getPickerRenderState: instagramInsightsPickerRenderState
        };

        chartTypes[widgetTypes.FOCUS_COMPANY_PIE_CHART] = _.extend({}, pieChart, {
            widgetId: widgetTypes.FOCUS_COMPANY_PIE_CHART,
            widgetGroupId: widgetGroupType.CHART,
            name: 'Focus Company Pie Chart',
            icon: 'charts/pie.svg',
            builderDescription: strings.favorites_chart_type_focus_pie_chart_description,
            widgetSupportsTitlePlacement: true,
            availableSources: null, // unset so that we get private sources too
            processProps: function (props, changed) {
                const me = this;

                _.defaults(props, {
                    nameDimensions: ['companyId', 'channel']
                });

                return superProcessProps(me, props, changed);
            }
        });

        chartTypes[widgetTypes.FOCUS_COMPANY_METRIC_LINE_CHART] = _.defaults({
            widgetId: widgetTypes.FOCUS_COMPANY_METRIC_LINE_CHART,
            name: 'Focus Company Time Series',
            icon: 'charts/line.svg',
            builderDescription: strings.favorites_chart_type_focus_time_series_description,
            availableSources: null // unset so that we get private sources too
        }, chartTypes[widgetTypes.METRIC_COMPANY_LINE_CHART]);
    }
})();
